import { Divider, Grid } from '@mui/material';
import { WrappedCarePlan } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/CarePlan';
import { WrappedPatient } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Patient';
import { WrappedTask } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Task';
import InfoRibbon from 'src/components/InfoRibbon';
import { InfoRibbonCarePlan, InfoRibbonPatientCustom, InfoRibbonServiceRequestCustom, InfoRibbonSubTask } from 'src/components/InfoRibbonSections';
import { Reference } from 'src/careflow/ph-core/fhir-client/resources';

export interface TaskInfoRibbonProps {
  carePlan: WrappedCarePlan | null;
  reference: Reference | null;
  taskBasedOn?: WrappedTask | null;
  patient: WrappedPatient | null;
  configurations: any;
  i18n: any;
}

const TaskInfoRibbon = ({ carePlan, reference, taskBasedOn, patient, configurations, i18n }: TaskInfoRibbonProps) =>  (
  <InfoRibbon containerSx={{ height: '60px', marginTop: 0, flexWrap: 'wrap' }} xs={12}>
    {carePlan &&
      <>
        <Grid container item xs={3.5} pl={2}>
          <InfoRibbonCarePlan 
            carePlan={carePlan} 
            configurations={configurations?.fhir} 
            i18n={i18n}
          />
        </Grid>
        <Divider orientation="vertical" flexItem sx={{ mr: '-1px', borderStyle: 'dashed' }} />
      </>
    }
    {reference && 
      <>
        <Grid container item xs={3.5} pl={2}>
          <InfoRibbonServiceRequestCustom reference={reference} i18n={i18n}/>
        </Grid>
        <Divider orientation="vertical" flexItem sx={{ mr: '-1px', borderStyle: 'dashed' }} />
      </>
    }
    {taskBasedOn && 
      <>
        <Grid container item xs={3.5} pl={2}>
          <InfoRibbonSubTask 
            task={taskBasedOn} 
            configurations={configurations?.fhir} 
            i18n={i18n}
          />
        </Grid>
        <Divider orientation="vertical" flexItem sx={{ mr: '-1px', borderStyle: 'dashed' }} />
      </>
    }
    {patient && 
      <>
        <Grid container item xs={4} pl={2}>
          <InfoRibbonPatientCustom 
            patient={patient} 
            configurations={configurations?.mpi} 
            i18n={i18n}
          />
        </Grid>
      </>
    }
  </InfoRibbon>
);

export default TaskInfoRibbon;